module.exports = __webpack_public_path__ + "img/RX-RAD-CONVENCIONAL-Salas-5-zoom.e7667ef1.png";